export default {
  name: 'inventaire-observation-admin',
  props: {
    value: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    canSave: { type: Boolean, default: false },
  },
}
